import http from "@/services/http-common";
import authHeader from "@/services/auth-header-login";

class wsAltarChallengeVotes {
	createVoteRme(data) {
		return http.post("/altar-challenge-rme-votes/", data, {
			headers: authHeader(),
		});
	}

	createVoteCommunity(data) {
		return http.post(
			"/altar-challenge-community-votes/?populate[rme_votes][fields]=altar_challenge",
			data,
			{
				headers: authHeader(),
			}
		);
	}

	myVoteRme(userId) {
		return http.post(
			`/altar-challenge-rme-votes/?filters[author][id][$eq]=${userId}`,
			{
				headers: authHeader(),
			}
		);
	}

	myVoteCommunity(userId) {
		return http.post(
			`/altar-challenge-community-votes/?filters[author][id][$eq]=${userId}`,
			{
				headers: authHeader(),
			}
		);
	}
}

export default new wsAltarChallengeVotes();
